import type React from 'react';

import { IconPlus } from '../Icon';
import { Button } from './wrapper';

export type AddButtonWidth = 'auto' | 'full';
interface AddButtonProps {
  children: React.ReactNode;
  title: string;
  disabled?: boolean;
  error?: boolean;
  isDragActive?: boolean;
  inputHeight?: boolean;
  icon?: React.ReactNode;
  width?: AddButtonWidth;
  onClick: () => void;
  testId?: string;
}

const AddButton = ({
  children,
  title,
  disabled,
  error,
  isDragActive,
  inputHeight,
  icon,
  width = 'full',
  onClick,
  testId,
}: AddButtonProps) => (
  <Button
    type="button"
    onClick={onClick}
    title={title}
    disabled={disabled}
    $isDragActive={isDragActive}
    $hasError={error}
    $inputHeight={inputHeight}
    $width={width}
    data-testid={testId}
  >
    {icon || <IconPlus />}
    {children}
  </Button>
);

export default AddButton;
